// import { WhichWeightAPIWithTokenOverride } from "WhichWeightAPI"
import { Fragment } from "react"

import ScreenFrame from 'components/Frame/ScreenFrame'

export default function APITestingView() {

    const athleteId = null
    const athleteEmail = null
    const athleteToken = null
    const athleteOrganizationId = null

    const coachId = null
    const coachEmail = null
    const coachToken = null
    const coachOrganizationId = null

    const billing_endpoint_definitions = [
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_auth',
            path: '/used_app_store_free_trial',
            jsonBody: {
                userId: athleteId
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_admin',
            path: '/user_app_store_server_notifications',
            jsonBody: {
                userId: athleteId
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_self_access',
            path: '/customer_id',
            jsonBody: {
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_auth',
            path: '/layer_versions',
            jsonBody: {},
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'none',
            path: '/android_app_store_server_notification_webhook',
            jsonBody: {
                message: {
                    data: "eyJ2ZXJzaW9uIjoiMS4wIiwicGFja2FnZU5hbWUiOiJjb20ud2hpY2h3ZWlnaHQud2hpY2h3ZWlnaHRhcHAiLCJldmVudFRpbWVNaWxsaXMiOiIxNzUwODY5NjAxMDE5Iiwic3Vic2NyaXB0aW9uTm90aWZpY2F0aW9uIjp7InZlcnNpb24iOiIxLjAiLCJub3RpZmljYXRpb25UeXBlIjoyLCJwdXJjaGFzZVRva2VuIjoib25taGRmZmpmbW5iZGtvbW1vbm9pcG5wLkFPLUoxT3g5UXBqWnFENlVYNkxiN3JGYURjQzJfTVZndHN0TXBzYWdjV1FmZEhDcXBtUENlQkl5MlpKQmU4MmgzSzltMkJ4ZTJpN1pHU2pXcW81Wkw2ZEhMRFdVNFNPVUtYUDFLOVEzM3puRlNydmRHNXJqal9FIiwic3Vic2NyaXB0aW9uSWQiOiJjb20ud2hpY2h3ZWlnaHQud2hpY2h3ZWlnaHRhcHAifX0=", 
                    messageId: "15310538365454626", 
                    message_id: "15310538365454626", 
                    publishTime: "2025-06-25T16:40:01.247Z", 
                    publish_time: "2025-06-25T16:40:01.247Z"
                }, 
                subscription: "projects/gentle-app-435220-q8/subscriptions/android_app_store_server_notifications-sub"
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'none',
            path: '/ios_app_store_server_notification_webhook',
            jsonBody: {
                signedPayload: null
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/native_subscription_info',
            jsonBody: {
                userId: athleteId,
                nativeSubscriptionInfo: {
                    transactionId: "2000000948484274", 
                    originalTransactionId: "2000000916548398", 
                    platform: "ios", 
                    productId: "com.whichweight.whichweightapp.block4"
                }
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/attach_payment_method_to_customer',
            jsonBody: {
                email: athleteEmail,
                stripePaymentMethodId: 'pm_1SFKCzBpzBH2MT3ijJPYpKYu'
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_auth',
            path: '/prices',
            jsonBody: {},
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/check_promo_code',
            jsonBody: {
                userId: athleteId,
                promoCode: 'UTMB2025'
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/track_promo_code_apply',
            jsonBody: {
                userId: athleteId,
                stripePromotionId: 'promo_1RyyhMBpzBH2MT3id9Kh9EUV',
                promoCode: 'UTMB2025'
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_admin',
            path: '/all_user_subscription_statuses',
            jsonBody: {},
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/create_subscription',
            jsonBody: {
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/cancel_subscription',
            jsonBody: {
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_self_access',
            path: '/subscription_details',
            jsonBody: {
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/subscription_payment_retry',
            jsonBody: {
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/resume_subscription',
            jsonBody: {
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_coach_organization_access',
            path: '/attach_payment_method_to_organization',
            jsonBody: {
                organizationId: coachOrganizationId
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_coach_organization_access',
            path: '/coach_bill_preview',
            jsonBody: {
                organizationId: coachOrganizationId
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_auth',
            path: '/coach_info',
            jsonBody: {
                email: coachEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_coach_access',
            path: '/coach_join_organization',
            jsonBody: {
                userId: 389,
                firstName: 'Test',
                lastName: 'Two',
                organizationCode: 'free-tier-testing-2025'
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'POST',
            decorator: 'require_admin',
            path: '/user_reset_account',
            jsonBody: {
                userId: athleteId,
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'BILLING',
            method: 'GET',
            decorator: 'require_auth',
            path: '/user_stripe_individual_membership_info',
            jsonBody: {
                email: athleteEmail
            },
            backgroundColor: 'bg-green-100'
        }
    ]

    const core_endpoint_definitions = [
        {
            token: athleteToken,
            service: 'CORE',
            method: 'GET',
            decorator: 'require_shared_access',
            path: '/assessment_list',
            jsonBody: {
                'email': athleteEmail
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            method: 'GET',
            decorator: 'require_coach_organization_access',
            path: '/organization_assessments',
            jsonBody: {
                organizationId: coachOrganizationId,
                requestingUserId: coachId
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            method: 'POST',
            decorator: 'require_self_access',
            path: '/membership_activation_checklist_track',
            jsonBody: {
                'userId': athleteId
            },
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/athlete_onboard_fitness_profile',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/athlete_onboard_personal_info',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/body_soreness_record',
            method: 'POST',
            jsonBody: {
                'userId': athleteId,
                'muscleKey': 'hip-right',
                'sorenessType': 'sharp',
                'sorenessScale': 5
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/body_soreness_records',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/track_branch_link_click',
            method: 'POST',
            jsonBody: {
                'userId': athleteId,
                'email': athleteEmail,
                'linkDataArray': JSON.stringify([
                    {
                        '~feature': 'test_feature',
                        '~channel': 'test_channel',
                        '~campaign': 'test_campaign',
                        '~id': 'test_id'
                    }
                ])
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/athlete_details',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/equipment_blacklist',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/archive_event',
            method: 'PATCH',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/edit_event',
            method: 'PATCH',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/event',
            method: 'POST',
            jsonBody: {
                traineeId: athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/events',
            method: 'GET',
            jsonBody: {
                traineeId: athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/activate_equipment_profile',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/create_equipment_profile',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/equipment_profiles',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/update_equipment_profile',
            method: 'PATCH',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/exercise/custom',
            method: 'POST',
            
            decorator: 'require_coach_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/exercise_directory',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_auth',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/exercise_instructions',
            method: 'GET',
            jsonBody: {
                exerciseId: 3
            },
            decorator: 'require_auth',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/exercise_swap_options',
            method: 'GET',
            jsonBody: {
                swapType: 'home',
                exerciseId: 3
            },
            decorator: 'require_auth',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/exercises',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_auth',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/user_feedback_item',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/attach_user_to_organization',
            method: 'PATCH',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/coach_create_organization',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/organization_details_by_code',
            method: 'GET',
            jsonBody: {
                organizationCode: 'kinesis-internal-2025'
            },
            decorator: 'require_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/organization_directory',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/organization_stats',
            method: 'GET',
            jsonBody: {
                organizationId: coachOrganizationId,
                requestingUserId: coachId
            },
            decorator: 'require_coach_organization_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/organization_trainee_workouts',
            method: 'GET',
            jsonBody: {
                organizationId: coachOrganizationId,
                requestingUserId: coachId
            },
            decorator: 'require_coach_organization_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/organization_trainees',
            method: 'GET',
            jsonBody: {
                organizationId: coachOrganizationId,
                requestingUserId: coachId
            },
            decorator: 'require_coach_organization_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/organization_trainers',
            method: 'GET',
            jsonBody: {
                organizationId: coachOrganizationId,
                requestingUserId: coachId
            },
            decorator: 'require_coach_organization_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/sports',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_auth',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/deauthenticate_terra_user',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/terra_backfill_post',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/terra_widget_session',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/trainee_fitness_profile',
            method: 'GET',
            jsonBody: {
                traineeId: athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/trainee_fitness_profile',
            method: 'POST',
            jsonBody: {
                traineeId: athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/user_directory',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/user_directory_internal_athletes_export',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/user_directory_internal_coaches_export',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/user_exercise_weight_recommendation_history',
            method: 'GET',
            jsonBody: {
                traineeId: athleteId,
                exerciseId: 46
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/user_info',
            method: 'GET',
            jsonBody: {
                'email': athleteEmail
            },
            decorator: 'require_auth',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/track_login',
            method: 'POST',
            jsonBody: {
                'userId': athleteId,
                'userType': 'trainee',
                'browser': 'Chrome',
                'device': 'Test Device',
                'operatingSystem': 'Test OS'
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/update_monthly_email_reminders_preference',
            method: 'POST',
            jsonBody: {
                'userId': athleteId,
                'allowMonthlyReminders': 1
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/user_recommendation_exercises',
            method: 'GET',
            jsonBody: {
                traineeId: athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/activity_data',
            method: 'GET',
            jsonBody: {
                'userId': athleteId,
                'activityType': 'recent'
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/all_wearable_activities',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/wearable_stats',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/override/wearable_latest',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/wearable_stats_calculate',
            method: 'POST',
            jsonBody: {
                'email': athleteEmail
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/bulk_workout_exercise',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/archive_workout',
            method: 'PATCH',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/workout',
            method: 'POST',
            jsonBody: {
                traineeId: athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'CORE',
            path: '/workout_summary',
            method: 'GET',
            jsonBody: {
                'workoutId': 1334
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        }
    ]

    const email_endpoint_definitions = [
        {
            token: athleteToken,
            service: 'EMAIL',
            path: '/request_account_deletion',
            method: 'POST',
            jsonBody: {
                'athleteFirstName': 'Jacob',
                'athleteLastName': 'Carlson',
                'athleteEmail': athleteEmail,
                'email': athleteEmail,
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'EMAIL',
            path: '/email_invite_records',
            method: 'GET',
            jsonBody: {
                organizationId: coachOrganizationId
            },
            decorator: 'require_coach_organization_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'EMAIL',
            path: '/invite_athlete_to_organization',
            method: 'POST',
            jsonBody: {
                organizationId: coachOrganizationId,
                organizationName: 'Test Org',
                organizationCode: 'test-org-code',
                coachId: coachId,
                recipient: athleteEmail
            },
            decorator: 'require_coach_organization_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'EMAIL',
            path: '/send_email',
            method: 'POST',
            jsonBody: {
                userId: athleteId,
                recipient: athleteEmail,
                subject: 'Parameter subject line!',
                emailTemplateKey: 'welcome_email_template'
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        }
    ]

    const program_endpoint_definitions = [
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/generate_all_program_week_lengths',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/trainee_injury',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_auth',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/trainee_injury_update',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/one_off_coach_override_post',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/coach_dashboard_generate_program_snapshot',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/training_chart_data',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/default_week_day_schedule_json',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/default_week_day_schedule_json',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/present_week_day_schedule_json',
            method: 'POST',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_self_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/athlete_app_weekly_calendar_data',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/completed_workout_data',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/week_workout_template_data',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_coach_athlete_access',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'PROGRAM',
            path: '/weight_recommendation',
            method: 'GET',
            jsonBody: {
                userId: athleteId,
                weekOfTheYearKey: '2026-week-05',
                workoutTemplateKey: 'strength-session-a',
                phaseIndex: 0,
                slotIndex: 0,
                exerciseId: 23,
                reps: 12,
                taper: 1,
                taperDampener: 1.0
            },
            decorator: 'require_shared_access',
            backgroundColor: 'bg-green-100'
        }
    ]

    const recommendation_endpoint_definitions = []

    const reporting_endpoint_definitions = [
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/branch_data',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/all_user_feedback',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/sign_up_count',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/most_active_users',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/past_week_active_users',
            method: 'GET',
            jsonBody: {},
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        },
        {
            token: athleteToken,
            service: 'REPORTING',
            path: '/user_activity',
            method: 'GET',
            jsonBody: {
                'userId': athleteId
            },
            decorator: 'require_admin',
            backgroundColor: 'bg-green-100'
        }
    ]

    const service_compose = {
        billing: billing_endpoint_definitions,
        core: core_endpoint_definitions,
        email: email_endpoint_definitions,
        program: program_endpoint_definitions,
        recommendation: recommendation_endpoint_definitions,
        reporting: reporting_endpoint_definitions
    }

    const OnFunctionDefinitionClicked = async (functionDefinition) => {

        // console.log(functionDefinition.service + " " + functionDefinition.path + " " + functionDefinition.method)

        // // TODO: Fix this function!!
        // // Token passed in as paramter is not actullay being set
        // const response = await WhichWeightAPIWithTokenOverride(
        //     functionDefinition.service, 
        //     functionDefinition.method,
        //     functionDefinition.path, 
        //     functionDefinition.jsonBody,
        //     functionDefinition.token
        // )

        // console.log(response?.data?.data)

    }

    return (
        <ScreenFrame limitWidth={false}>
            {/* Athlete Info */}
            <div className="grid grid-cols-4 gap-x-4"> 
                <div className="flex items-center gap-x-4">
                    <p className="w-32">Athlete Id:</p>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {athleteId === null ? 'None' : athleteId}
                    </p>
                </div>

                <div className="flex items-center gap-x-4">
                    <p className="w-32">Athlete Email:</p>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {athleteEmail === null ? 'None' : athleteEmail}
                    </p>
                </div>

                <div className="flex items-center gap-x-4">
                    <div>
                        <p className="w-32">Athlete Token:</p>
                    </div>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {athleteToken === null ? 'None' : athleteToken}
                    </p>
                </div>

                <div className="flex items-center gap-x-4">
                    <p className="w-32">Athlete Org Id:</p>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {athleteOrganizationId === null ? 'None' : athleteOrganizationId}
                    </p>
                </div>
            </div>

            {/* Coach Info */}
            <div className="grid grid-cols-4 gap-x-4"> 
                <div className="flex items-center gap-x-4">
                    <p className="w-32">Coach Id:</p>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {coachId === null ? 'None' : coachId}
                    </p>
                </div>

                <div className="flex items-center gap-x-4">
                    <p className="w-32">Coach Email:</p>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {coachEmail === null ? 'None' : coachEmail}
                    </p>
                </div>

                <div className="flex items-center gap-x-4">
                    <div>
                        <p className="w-32">Coach Token:</p>
                    </div>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {coachToken === null ? 'None' : coachToken}
                    </p>
                </div>

                <div className="flex items-center gap-x-4">
                    <p className="w-32">Coach Org Id:</p>
                    <p className="flex-grow border border-gray-400 rounded-md p-2 truncate">
                        {coachOrganizationId === null ? 'None' : coachOrganizationId}
                    </p>
                </div>
            </div>

            {/* Function Definitions */}
            <div className='border border-gray-400 rounded-lg overflow-hidden divide-y divide-gray-400'>
                <div className="grid grid-cols-8 bg-gray-200 font-semibold">
                    <div className="col-span-1 p-1 text-xs">Service</div>
                    <div className="col-span-2 p-1 text-xs">Decorator</div>
                    <div className="col-span-2 p-1 text-xs">Path</div>
                    <div className="col-span-1 p-1 text-xs">Method</div>
                </div>

                {Object.keys(service_compose).map((service, index) => (
                    <Fragment key={index}>
                        {service_compose[service].map((functionDefinition, index) => (
                            <div 
                                key={index}
                                className={`
                                    grid grid-cols-8 hover:opacity-80 cursor-pointer
                                    ${functionDefinition.backgroundColor}
                                `}
                                onClick={() => OnFunctionDefinitionClicked(functionDefinition)}
                            >
                                <div className="col-span-1 p-1 text-sm">{functionDefinition.service}</div>
                                <div className="col-span-2 p-1 text-sm">{functionDefinition.decorator}</div>
                                <div className="col-span-2 p-1 text-sm">{functionDefinition.path}</div>
                                <div className="col-span-1 p-1 text-sm">{functionDefinition.method}</div>
                            </div>
                        ))}
                    </Fragment>
                ))}
            </div>
        </ScreenFrame>
    )
}